import React from "react";
import { Navigate } from "react-router-dom";

// Main Dashboard
import BusinessDashboard from "../pages/BusinessDashboard";

// Project Pages
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";
import ProjectEndpoints from "../pages/Projects/Endpoints";
import ProjectJobs from "../pages/Projects/Jobs";
import ProjectApiKeys from "../pages/Projects/ApiKeys";

// Authentication Pages
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import ResetPasswordPage from "../pages/Authentication/ResetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import UserProfile from "../pages/Authentication/user-profile";
import CompanyProfile from "../pages/Authentication/company-profile";
import BillingUpgrade from "../pages/Authentication/billing-upgrade";

// Billing & Team Management
import Billing from "../pages/Billing";
import TeamManagement from "../pages/Team";
import ApiKeysManagement from "../pages/ApiKeys";

// Contact Us
import ContactUs from "../pages/ContactUs";

// Error Pages (minimal - keep basic ones)
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

const authProtectedRoutes = [
  // Main Dashboard
  { path: "/dashboard", component: <BusinessDashboard /> },
  { path: "/index", component: <BusinessDashboard /> },

  // Projects
  { path: "/apps-projects-list", component: <ProjectList /> },
  { path: "/apps-projects-overview", component: <ProjectOverview /> },
  { path: "/apps-projects-create", component: <CreateProject /> },
  { path: "/projects/:projectId/endpoints", component: <ProjectEndpoints /> },
  { path: "/projects/:projectId/jobs", component: <ProjectJobs /> },
  { path: "/projects/:projectId/api-keys", component: <ProjectApiKeys /> },

  // User Profile & Company
  { path: "/profile", component: <UserProfile /> },
  { path: "/company-profile", component: <CompanyProfile /> },

  // Billing & Subscriptions
  { path: "/billing", component: <Billing /> },
  { path: "/billing-upgrade", component: <BillingUpgrade /> },

  // Team & API Keys
  { path: "/team-management", component: <TeamManagement /> },
  { path: "/api-token", component: <ApiKeysManagement /> },

  // Contact Us
  { path: "/contact-us", component: <ContactUs /> },

  // Default route
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Pages
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password/:email/:resetToken", component: <ResetPasswordPage /> },
  { path: "/register", component: <Register /> },

  // Error Pages
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-500", component: <Error500 /> },
];

export { authProtectedRoutes, publicRoutes };
